export const VEHICLE_STATE_IDS = {
  NEW: 'NEW',
  USED: 'USED'
}

export const TARGET_BUYER_IDS = {
  PRIVATES: 'PRIVATES',
  BUSINESS: 'BUSINESS'
}

export const VEHICLE_STATE_LITERALS = {
  [VEHICLE_STATE_IDS.NEW]: 'COMMON.OFFER_TYPE.NEW',
  [VEHICLE_STATE_IDS.USED]: 'COMMON.PRE_OWNED'
}

export const CONTEXTS = {}

export const DEFAULT_RELATED_ADS_COUNT = 4

/**
 * @exports SEGMENTS
 * Subscription segments
 *
 */
export const SEGMENTS = {}

export const DEFAULT_SEGMENT = SEGMENTS.COMPACT

/**
 * @exports modelIdMapping
 * Mapping our modelIds to Subscription segments
 *
 */
export const modelIdMapping = {}

/**
 * @exports SEGMENTS
 * Maps subscription contexts to attribution link param values
 *
 */
export const SUBSCRIPTION_REFERRALS = {}

export const URL_LANDING_SUBSCRIPTION = ''
